"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dropdown = _interopRequireDefault(require("react-bootstrap/lib/Dropdown"));

var _MenuItem = _interopRequireDefault(require("react-bootstrap/lib/MenuItem"));

var _Glyphicon = _interopRequireDefault(require("react-bootstrap/lib/Glyphicon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var buttonUnsetStyles = {
  textTransform: "unset",
  letterSpacing: "unset",
  height: "unset"
};

var callWithEventTargetText = function callWithEventTargetText(f) {
  return function (eventKey, event) {
    event.preventDefault();
    return f(event.target.text);
  };
};

var orderingIcon = function orderingIcon(ordering) {
  switch (ordering) {
    case "Alphabetical order":
      return "sort-by-alphabet";

    case "Expression rank":
      return "sort-by-attributes-alt";

    case "By experiment type":
      return "sort-by-order";

    default:
      return "sort-by-order";
  }
};

var OrderingsDropdown = function OrderingsDropdown(_ref) {
  var allOptions = _ref.allOptions,
      currentOption = _ref.currentOption,
      onChangeCurrentOption = _ref.onChangeCurrentOption,
      title = _ref.title,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    id: "orderings-dropdown",
    onSelect: callWithEventTargetText(onChangeCurrentOption),
    title: title,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Toggle, {
    bsSize: "small",
    style: buttonUnsetStyles
  }, /*#__PURE__*/_react["default"].createElement(_Glyphicon["default"], {
    glyph: orderingIcon(currentOption)
  }), currentOption), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Menu, {
    bsSize: "small"
  }, allOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      style: {
        listStyleImage: "none"
      },
      key: option,
      href: "#",
      active: option === currentOption
    }, option);
  }))));
};

OrderingsDropdown.propTypes = {
  allOptions: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  currentOption: _propTypes["default"].string.isRequired,
  onChangeCurrentOption: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool.isRequired
};
var _default = OrderingsDropdown;
exports["default"] = _default;